export const countries = [
  {
      "value": "South Georgia",
      "label": "South Georgia"
  },
  {
      "value": "Grenada",
      "label": "Grenada"
  },
  {
      "value": "Switzerland",
      "label": "Switzerland"
  },
  {
      "value": "Sierra Leone",
      "label": "Sierra Leone"
  },
  {
      "value": "Hungary",
      "label": "Hungary"
  },
  {
      "value": "Taiwan",
      "label": "Taiwan"
  },
  {
      "value": "Wallis and Futuna",
      "label": "Wallis and Futuna"
  },
  {
      "value": "Barbados",
      "label": "Barbados"
  },
  {
      "value": "Pitcairn Islands",
      "label": "Pitcairn Islands"
  },
  {
      "value": "Ivory Coast",
      "label": "Ivory Coast"
  },
  {
      "value": "Tunisia",
      "label": "Tunisia"
  },
  {
      "value": "Italy",
      "label": "Italy"
  },
  {
      "value": "Benin",
      "label": "Benin"
  },
  {
      "value": "Indonesia",
      "label": "Indonesia"
  },
  {
      "value": "Cape Verde",
      "label": "Cape Verde"
  },
  {
      "value": "Saint Kitts and Nevis",
      "label": "Saint Kitts and Nevis"
  },
  {
      "value": "Laos",
      "label": "Laos"
  },
  {
      "value": "Caribbean Netherlands",
      "label": "Caribbean Netherlands"
  },
  {
      "value": "Uganda",
      "label": "Uganda"
  },
  {
      "value": "Andorra",
      "label": "Andorra"
  },
  {
      "value": "Burundi",
      "label": "Burundi"
  },
  {
      "value": "South Africa",
      "label": "South Africa"
  },
  {
      "value": "France",
      "label": "France"
  },
  {
      "value": "Libya",
      "label": "Libya"
  },
  {
      "value": "Mexico",
      "label": "Mexico"
  },
  {
      "value": "Gabon",
      "label": "Gabon"
  },
  {
      "value": "Northern Mariana Islands",
      "label": "Northern Mariana Islands"
  },
  {
      "value": "North Macedonia",
      "label": "North Macedonia"
  },
  {
      "value": "China",
      "label": "China"
  },
  {
      "value": "Yemen",
      "label": "Yemen"
  },
  {
      "value": "Saint Barthélemy",
      "label": "Saint Barthélemy"
  },
  {
      "value": "Guernsey",
      "label": "Guernsey"
  },
  {
      "value": "Solomon Islands",
      "label": "Solomon Islands"
  },
  {
      "value": "Svalbard and Jan Mayen",
      "label": "Svalbard and Jan Mayen"
  },
  {
      "value": "Faroe Islands",
      "label": "Faroe Islands"
  },
  {
      "value": "Uzbekistan",
      "label": "Uzbekistan"
  },
  {
      "value": "Egypt",
      "label": "Egypt"
  },
  {
      "value": "Senegal",
      "label": "Senegal"
  },
  {
      "value": "Sri Lanka",
      "label": "Sri Lanka"
  },
  {
      "value": "Palestine",
      "label": "Palestine"
  },
  {
      "value": "Bangladesh",
      "label": "Bangladesh"
  },
  {
      "value": "Peru",
      "label": "Peru"
  },
  {
      "value": "Singapore",
      "label": "Singapore"
  },
  {
      "value": "Turkey",
      "label": "Turkey"
  },
  {
      "value": "Afghanistan",
      "label": "Afghanistan"
  },
  {
      "value": "Aruba",
      "label": "Aruba"
  },
  {
      "value": "Cook Islands",
      "label": "Cook Islands"
  },
  {
      "value": "United Kingdom",
      "label": "United Kingdom"
  },
  {
      "value": "Zambia",
      "label": "Zambia"
  },
  {
      "value": "Finland",
      "label": "Finland"
  },
  {
      "value": "Niger",
      "label": "Niger"
  },
  {
      "value": "Christmas Island",
      "label": "Christmas Island"
  },
  {
      "value": "Tokelau",
      "label": "Tokelau"
  },
  {
      "value": "Guinea-Bissau",
      "label": "Guinea-Bissau"
  },
  {
      "value": "Azerbaijan",
      "label": "Azerbaijan"
  },
  {
      "value": "Réunion",
      "label": "Réunion"
  },
  {
      "value": "Djibouti",
      "label": "Djibouti"
  },
  {
      "value": "North Korea",
      "label": "North Korea"
  },
  {
      "value": "Mauritius",
      "label": "Mauritius"
  },
  {
      "value": "Montserrat",
      "label": "Montserrat"
  },
  {
      "value": "United States Virgin Islands",
      "label": "United States Virgin Islands"
  },
  {
      "value": "Colombia",
      "label": "Colombia"
  },
  {
      "value": "Greece",
      "label": "Greece"
  },
  {
      "value": "Croatia",
      "label": "Croatia"
  },
  {
      "value": "Morocco",
      "label": "Morocco"
  },
  {
      "value": "Algeria",
      "label": "Algeria"
  },
  {
      "value": "Antarctica",
      "label": "Antarctica"
  },
  {
      "value": "Netherlands",
      "label": "Netherlands"
  },
  {
      "value": "Sudan",
      "label": "Sudan"
  },
  {
      "value": "Fiji",
      "label": "Fiji"
  },
  {
      "value": "Liechtenstein",
      "label": "Liechtenstein"
  },
  {
      "value": "Nepal",
      "label": "Nepal"
  },
  {
      "value": "Puerto Rico",
      "label": "Puerto Rico"
  },
  {
      "value": "Georgia",
      "label": "Georgia"
  },
  {
      "value": "Pakistan",
      "label": "Pakistan"
  },
  {
      "value": "Monaco",
      "label": "Monaco"
  },
  {
      "value": "Botswana",
      "label": "Botswana"
  },
  {
      "value": "Lebanon",
      "label": "Lebanon"
  },
  {
      "value": "Papua New Guinea",
      "label": "Papua New Guinea"
  },
  {
      "value": "Mayotte",
      "label": "Mayotte"
  },
  {
      "value": "Dominican Republic",
      "label": "Dominican Republic"
  },
  {
      "value": "Norfolk Island",
      "label": "Norfolk Island"
  },
  {
      "value": "Bouvet Island",
      "label": "Bouvet Island"
  },
  {
      "value": "Qatar",
      "label": "Qatar"
  },
  {
      "value": "Madagascar",
      "label": "Madagascar"
  },
  {
      "value": "India",
      "label": "India"
  },
  {
      "value": "Syria",
      "label": "Syria"
  },
  {
      "value": "Montenegro",
      "label": "Montenegro"
  },
  {
      "value": "Eswatini",
      "label": "Eswatini"
  },
  {
      "value": "Paraguay",
      "label": "Paraguay"
  },
  {
      "value": "El Salvador",
      "label": "El Salvador"
  },
  {
      "value": "Ukraine",
      "label": "Ukraine"
  },
  {
      "value": "Isle of Man",
      "label": "Isle of Man"
  },
  {
      "value": "Namibia",
      "label": "Namibia"
  },
  {
      "value": "United Arab Emirates",
      "label": "United Arab Emirates"
  },
  {
      "value": "Bulgaria",
      "label": "Bulgaria"
  },
  {
      "value": "Greenland",
      "label": "Greenland"
  },
  {
      "value": "Germany",
      "label": "Germany"
  },
  {
      "value": "Cambodia",
      "label": "Cambodia"
  },
  {
      "value": "Iraq",
      "label": "Iraq"
  },
  {
      "value": "French Southern and Antarctic Lands",
      "label": "French Southern and Antarctic Lands"
  },
  {
      "value": "Sweden",
      "label": "Sweden"
  },
  {
      "value": "Cuba",
      "label": "Cuba"
  },
  {
      "value": "Kyrgyzstan",
      "label": "Kyrgyzstan"
  },
  {
      "value": "Russia",
      "label": "Russia"
  },
  {
      "value": "Malaysia",
      "label": "Malaysia"
  },
  {
      "value": "São Tomé and Príncipe",
      "label": "São Tomé and Príncipe"
  },
  {
      "value": "Cyprus",
      "label": "Cyprus"
  },
  {
      "value": "Canada",
      "label": "Canada"
  },
  {
      "value": "Malawi",
      "label": "Malawi"
  },
  {
      "value": "Saudi Arabia",
      "label": "Saudi Arabia"
  },
  {
      "value": "Bosnia and Herzegovina",
      "label": "Bosnia and Herzegovina"
  },
  {
      "value": "Ethiopia",
      "label": "Ethiopia"
  },
  {
      "value": "Spain",
      "label": "Spain"
  },
  {
      "value": "Slovenia",
      "label": "Slovenia"
  },
  {
      "value": "Oman",
      "label": "Oman"
  },
  {
      "value": "Saint Pierre and Miquelon",
      "label": "Saint Pierre and Miquelon"
  },
  {
      "value": "Macau",
      "label": "Macau"
  },
  {
      "value": "San Marino",
      "label": "San Marino"
  },
  {
      "value": "Lesotho",
      "label": "Lesotho"
  },
  {
      "value": "Marshall Islands",
      "label": "Marshall Islands"
  },
  {
      "value": "Sint Maarten",
      "label": "Sint Maarten"
  },
  {
      "value": "Iceland",
      "label": "Iceland"
  },
  {
      "value": "Luxembourg",
      "label": "Luxembourg"
  },
  {
      "value": "Argentina",
      "label": "Argentina"
  },
  {
      "value": "Turks and Caicos Islands",
      "label": "Turks and Caicos Islands"
  },
  {
      "value": "Nauru",
      "label": "Nauru"
  },
  {
      "value": "Cocos (Keeling) Islands",
      "label": "Cocos (Keeling) Islands"
  },
  {
      "value": "Western Sahara",
      "label": "Western Sahara"
  },
  {
      "value": "Dominica",
      "label": "Dominica"
  },
  {
      "value": "Costa Rica",
      "label": "Costa Rica"
  },
  {
      "value": "Australia",
      "label": "Australia"
  },
  {
      "value": "Thailand",
      "label": "Thailand"
  },
  {
      "value": "Haiti",
      "label": "Haiti"
  },
  {
      "value": "Tuvalu",
      "label": "Tuvalu"
  },
  {
      "value": "Honduras",
      "label": "Honduras"
  },
  {
      "value": "Equatorial Guinea",
      "label": "Equatorial Guinea"
  },
  {
      "value": "Saint Lucia",
      "label": "Saint Lucia"
  },
  {
      "value": "French Polynesia",
      "label": "French Polynesia"
  },
  {
      "value": "Belarus",
      "label": "Belarus"
  },
  {
      "value": "Latvia",
      "label": "Latvia"
  },
  {
      "value": "Palau",
      "label": "Palau"
  },
  {
      "value": "Guadeloupe",
      "label": "Guadeloupe"
  },
  {
      "value": "Philippines",
      "label": "Philippines"
  },
  {
      "value": "Gibraltar",
      "label": "Gibraltar"
  },
  {
      "value": "Denmark",
      "label": "Denmark"
  },
  {
      "value": "Cameroon",
      "label": "Cameroon"
  },
  {
      "value": "Guinea",
      "label": "Guinea"
  },
  {
      "value": "Bahrain",
      "label": "Bahrain"
  },
  {
      "value": "Suriname",
      "label": "Suriname"
  },
  {
      "value": "DR Congo",
      "label": "DR Congo"
  },
  {
      "value": "Somalia",
      "label": "Somalia"
  },
  {
      "value": "Czechia",
      "label": "Czechia"
  },
  {
      "value": "New Caledonia",
      "label": "New Caledonia"
  },
  {
      "value": "Vanuatu",
      "label": "Vanuatu"
  },
  {
      "value": "Saint Helena, Ascension and Tristan da Cunha",
      "label": "Saint Helena, Ascension and Tristan da Cunha"
  },
  {
      "value": "Togo",
      "label": "Togo"
  },
  {
      "value": "British Virgin Islands",
      "label": "British Virgin Islands"
  },
  {
      "value": "Kenya",
      "label": "Kenya"
  },
  {
      "value": "Niue",
      "label": "Niue"
  },
  {
      "value": "Heard Island and McDonald Islands",
      "label": "Heard Island and McDonald Islands"
  },
  {
      "value": "Rwanda",
      "label": "Rwanda"
  },
  {
      "value": "Estonia",
      "label": "Estonia"
  },
  {
      "value": "Romania",
      "label": "Romania"
  },
  {
      "value": "Trinidad and Tobago",
      "label": "Trinidad and Tobago"
  },
  {
      "value": "Guyana",
      "label": "Guyana"
  },
  {
      "value": "Timor-Leste",
      "label": "Timor-Leste"
  },
  {
      "value": "Vietnam",
      "label": "Vietnam"
  },
  {
      "value": "Uruguay",
      "label": "Uruguay"
  },
  {
      "value": "Vatican City",
      "label": "Vatican City"
  },
  {
      "value": "Hong Kong",
      "label": "Hong Kong"
  },
  {
      "value": "Austria",
      "label": "Austria"
  },
  {
      "value": "Antigua and Barbuda",
      "label": "Antigua and Barbuda"
  },
  {
      "value": "Turkmenistan",
      "label": "Turkmenistan"
  },
  {
      "value": "Mozambique",
      "label": "Mozambique"
  },
  {
      "value": "Panama",
      "label": "Panama"
  },
  {
      "value": "Micronesia",
      "label": "Micronesia"
  },
  {
      "value": "Ireland",
      "label": "Ireland"
  },
  {
      "value": "Curaçao",
      "label": "Curaçao"
  },
  {
      "value": "French Guiana",
      "label": "French Guiana"
  },
  {
      "value": "Norway",
      "label": "Norway"
  },
  {
      "value": "Åland Islands",
      "label": "Åland Islands"
  },
  {
      "value": "Central African Republic",
      "label": "Central African Republic"
  },
  {
      "value": "Burkina Faso",
      "label": "Burkina Faso"
  },
  {
      "value": "Eritrea",
      "label": "Eritrea"
  },
  {
      "value": "Tanzania",
      "label": "Tanzania"
  },
  {
      "value": "South Korea",
      "label": "South Korea"
  },
  {
      "value": "Jordan",
      "label": "Jordan"
  },
  {
      "value": "Mauritania",
      "label": "Mauritania"
  },
  {
      "value": "Lithuania",
      "label": "Lithuania"
  },
  {
      "value": "United States Minor Outlying Islands",
      "label": "United States Minor Outlying Islands"
  },
  {
      "value": "Slovakia",
      "label": "Slovakia"
  },
  {
      "value": "Angola",
      "label": "Angola"
  },
  {
      "value": "Kazakhstan",
      "label": "Kazakhstan"
  },
  {
      "value": "Moldova",
      "label": "Moldova"
  },
  {
      "value": "Mali",
      "label": "Mali"
  },
  {
      "value": "Falkland Islands",
      "label": "Falkland Islands"
  },
  {
      "value": "Armenia",
      "label": "Armenia"
  },
  {
      "value": "Samoa",
      "label": "Samoa"
  },
  {
      "value": "Jersey",
      "label": "Jersey"
  },
  {
      "value": "Japan",
      "label": "Japan"
  },
  {
      "value": "Bolivia",
      "label": "Bolivia"
  },
  {
      "value": "Chile",
      "label": "Chile"
  },
  {
      "value": "United States",
      "label": "United States"
  },
  {
      "value": "Saint Vincent and the Grenadines",
      "label": "Saint Vincent and the Grenadines"
  },
  {
      "value": "Bermuda",
      "label": "Bermuda"
  },
  {
      "value": "Seychelles",
      "label": "Seychelles"
  },
  {
      "value": "British Indian Ocean Territory",
      "label": "British Indian Ocean Territory"
  },
  {
      "value": "Guatemala",
      "label": "Guatemala"
  },
  {
      "value": "Ecuador",
      "label": "Ecuador"
  },
  {
      "value": "Martinique",
      "label": "Martinique"
  },
  {
      "value": "Tajikistan",
      "label": "Tajikistan"
  },
  {
      "value": "Malta",
      "label": "Malta"
  },
  {
      "value": "Gambia",
      "label": "Gambia"
  },
  {
      "value": "Nigeria",
      "label": "Nigeria"
  },
  {
      "value": "Bahamas",
      "label": "Bahamas"
  },
  {
      "value": "Kosovo",
      "label": "Kosovo"
  },
  {
      "value": "Kuwait",
      "label": "Kuwait"
  },
  {
      "value": "Maldives",
      "label": "Maldives"
  },
  {
      "value": "South Sudan",
      "label": "South Sudan"
  },
  {
      "value": "Iran",
      "label": "Iran"
  },
  {
      "value": "Albania",
      "label": "Albania"
  },
  {
      "value": "Brazil",
      "label": "Brazil"
  },
  {
      "value": "Serbia",
      "label": "Serbia"
  },
  {
      "value": "Belize",
      "label": "Belize"
  },
  {
      "value": "Myanmar",
      "label": "Myanmar"
  },
  {
      "value": "Bhutan",
      "label": "Bhutan"
  },
  {
      "value": "Venezuela",
      "label": "Venezuela"
  },
  {
      "value": "Liberia",
      "label": "Liberia"
  },
  {
      "value": "Jamaica",
      "label": "Jamaica"
  },
  {
      "value": "Poland",
      "label": "Poland"
  },
  {
      "value": "Cayman Islands",
      "label": "Cayman Islands"
  },
  {
      "value": "Brunei",
      "label": "Brunei"
  },
  {
      "value": "Comoros",
      "label": "Comoros"
  },
  {
      "value": "Guam",
      "label": "Guam"
  },
  {
      "value": "Tonga",
      "label": "Tonga"
  },
  {
      "value": "Kiribati",
      "label": "Kiribati"
  },
  {
      "value": "Ghana",
      "label": "Ghana"
  },
  {
      "value": "Chad",
      "label": "Chad"
  },
  {
      "value": "Zimbabwe",
      "label": "Zimbabwe"
  },
  {
      "value": "Saint Martin",
      "label": "Saint Martin"
  },
  {
      "value": "Mongolia",
      "label": "Mongolia"
  },
  {
      "value": "Portugal",
      "label": "Portugal"
  },
  {
      "value": "American Samoa",
      "label": "American Samoa"
  },
  {
      "value": "Republic of the Congo",
      "label": "Republic of the Congo"
  },
  {
      "value": "Belgium",
      "label": "Belgium"
  },
  {
      "value": "Israel",
      "label": "Israel"
  },
  {
      "value": "New Zealand",
      "label": "New Zealand"
  },
  {
      "value": "Nicaragua",
      "label": "Nicaragua"
  },
  {
      "value": "Anguilla",
      "label": "Anguilla"
  }
]